import React from "react";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const Menu = ({ width = "24px", height = "18px", fill }) =>
  websiteName === "bricostore" ? (
    // Material Design "menu" (24x24, Apache-2.0). Honor the fill prop, else currentColor.
    <svg
      className="fill-current"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || "currentColor"}
        d="M3 18h18v-2H3v2Zm0-5h18v-2H3v2Zm0-7v2h18V6H3Z"
      />
    </svg>
  ) : (
    <svg
      className="fill-current"
      width={width}
      height={height}
      viewBox="0 0 24 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1">
        <g transform="translate(-10.000000, -127.000000)" fill={fill}>
          <rect x="10" y="135" width="24" height="2" rx="1"></rect>
          <rect x="10" y="143" width="24" height="2" rx="1"></rect>
          <rect x="10" y="127" width="24" height="2" rx="1"></rect>
        </g>
      </g>
    </svg>
  );

export default Menu;
